import { SVGProps, Ref, forwardRef } from 'react';

export const PinOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.08 14.608a4.08 4.08 0 0 0 1.154-3.461l-.193-1.346 3.267-3.267 1.202 1.202.99-.99L9.25.496l-.99.99 1.202 1.202-3.267 3.267-1.346-.192a4.08 4.08 0 0 0-3.46 1.152l-.722.722 3.354 3.355L.5 14.5l1 1 3.51-3.518L8.36 15.33zm-.524-5.302.292 2.039a2.68 2.68 0 0 1-.508 1.986L2.666 7.657a2.68 2.68 0 0 1 1.985-.509l2.04.292 3.761-3.762 1.866 1.866z"
                fill="currentColor"
            />
        </g>
    </svg>
));
PinOutlinedSize16Glyph.displayName = 'PinOutlinedSize16Glyph';
